var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2L15.9 9.29995C16.0834 9.11662 16.3167 9.02495 16.6 9.02495C16.8834 9.02495 17.1167 9.11662 17.3 9.29995C17.4834 9.48328 17.575 9.71662 17.575 9.99995C17.575 10.2833 17.4834 10.5166 17.3 10.7L12.7 15.3C12.6 15.4 12.4917 15.4708 12.375 15.5125C12.2584 15.5541 12.1334 15.575 12 15.575C11.8667 15.575 11.7417 15.5541 11.625 15.5125C11.5084 15.4708 11.4 15.4 11.3 15.3L6.70005 10.7C6.51672 10.5166 6.42505 10.2833 6.42505 9.99995C6.42505 9.71662 6.51672 9.48328 6.70005 9.29995C6.88338 9.11662 7.11672 9.02495 7.40005 9.02495C7.68338 9.02495 7.91672 9.11662 8.10005 9.29995L12 13.2Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.3a3d59f311f3a72e661c2fbf6c132605.svg";
export { ForwardRef as ReactComponent };